// extracted by mini-css-extract-plugin
export default {"frameWrapper":"CUObDuHz","_shorts":"UbTEr8B2","frame":"xxD53ksS"};